import React from 'react';
import { inject, observer } from 'mobx-react';
import { roundToLocaleString } from '../../../../../../../../../../../../../../shared';
import { Icon } from '../../../../../../../../../../../../../UiLibrary';
import { StyledPrice, StyledText, StyledWrapper } from './styled';

const CashBackInfo = inject('store')(
    observer(({ store }) => {
        const variant = store.product.variants.currentVariantData;
        const color = store.view.customizations.cashBack.color;
        const loading = store.product.variants.loading;

        return (
            <StyledWrapper>
                <StyledText type='body2' color={color}>
                    Cash back
                </StyledText>
                <StyledText data-e2e='cashback-value' type='body2' color={color}>
                    {loading ? <Icon.Loader size='30px' /> : null}
                    <StyledPrice $loading={loading}>${roundToLocaleString(variant.cashbackPrice)}</StyledPrice>
                </StyledText>
            </StyledWrapper>
        );
    })
);

export default CashBackInfo;
